<a class="nav-link dropdown-toggle white btn-hover-pepsico fnt-13" href="#!" role="button" id="dropdownMenuLink22"
  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <svg-icon svgName="bi-heart" [width]="23" [height]="23" />
  @if(wishListDataService.hasWishLists()){
  <span class="icon-button__badge2">
    {{ wishListDataService.wishListCounter() }}
  </span>
  }
</a>
<div class="hover-label">Lista de deseos</div>
<div class="dropdown-menu notificationBox" aria-labelledby="dropdownMenuLink22">
  <div class="notificationTriangle-wishlist-dekstop is-active"></div>
  @if(wishListDataService.hasWishLists()){
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Artículos en tu Lista de deseos
    </div>
    <div class="notificationHeader--unread">
      <div>
        {{ wishListDataService.wishListCounter() }}
        {{ wishListDataService.wishListCounter() | i18nPlural: wishListMap()}}
      </div>
    </div>
  </div>
  <div>
    <div class="notificationList">
      <div>
        @for (wishList of wishListDataService.wishListData(); track wishList.idValue) {
        <div class="notification" (click)="navigateToWishList(wishList.idValue)">
          <div class="container">
            <div class="row img-carrito">
              <div class="col-sm">
                <p class="fnt-12">{{ wishList.textValue }}</p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="container">
      <div class="row jf-center">
        <button type="button" routerLink="wishlist" class="btn btn-red carrito-btn-2 w-290">
          Ver lista de deseos
        </button>
      </div>
    </div>
  </div>
  } @else {
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Actualmente no tienes lista de deseos
    </div>
  </div>
  }
</div>